import React from 'react';
import {observer, inject} from 'mobx-react';
import {PropTypes} from 'prop-types';

import {FAQ} from '../components/common/faq.jsx';
import faqData from '../content/faq-data.json';
const { faqs } = faqData;

@inject('store')
@observer
export class FaqPage extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    this.userStore = this.props.store.userStore;
  }

  render() {
    return (<section className="faq-page">
      <div className="faq-header">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-10 offset-sm-1">
              <h1>Frequently Asked&nbsp;Questions</h1>
              
            </div>
          </div>
        </div>
      </div>
      <FAQ faqData={faqs} userRolesArray={this.userStore.user.roles} />
    </section>);
  }
}
